export const ANNUAL_TIER = 'Annual' as const;
